import { BarBottomNavTemplate, BarBottomNavTemplateProps } from "./template";

export type BarBottomNavProps = BarBottomNavTemplateProps;

export const BarBottomNav = (props: BarBottomNavProps): JSX.Element => {
  return <BarBottomNavTemplate {...props} />;
};
